// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3-mSc","ranges":"BmiRanges_ranges__13lTC"};